import { takeLatest, call, put, select } from 'redux-saga/effects'
import * as actions from './actions'
import { startLoading, stopLoading, enqueueSnackbar } from '../root/actions'
import axios from 'axios'
import { getSagasMsgs } from '../root/selectors'

export const watchApiKeysSaga = [
    takeLatest(actions.API_KEYS_REQUEST, getApiKeys),
    takeLatest(actions.CREATE_API_KEY, createApiKey),
    takeLatest(actions.DELETE_API_KEY, deleteApiKey),
    takeLatest(actions.API_KEY_REQUEST, getApiKey)
]

function* getApiKeys(action) {
    const sagasMsgs = yield select(getSagasMsgs)
    try {
        yield put(startLoading())
        const response = yield call(getApiKeysRequest)
        yield put(actions.apiKeysSuccess(response))
        yield put(stopLoading())
    } catch (ex) {
        yield put(actions.apiKeysError())
        yield put(
            enqueueSnackbar({
                message: sagasMsgs.getApiKeysEx,
                options: {
                    variant: 'error'
                }
            })
        )
        yield put(stopLoading())
    }
}

async function getApiKeysRequest() {
    const response = await axios.get(`${process.env.API_URL}/api-keys`)
    return response.data
}

function* createApiKey(action) {
    const sagasMsgs = yield select(getSagasMsgs)
    try {
        yield call(createApiKeyRequest, action.body)
        yield put(actions.createApiKeySuccess())
        yield put(
            enqueueSnackbar({
                message: sagasMsgs.createApiKeyRes,
                options: {
                    variant: 'success'
                }
            })
        )
        yield put(actions.apiKeysRequest())
    } catch (ex) {
        yield put(actions.createApiKeyError())
        yield put(
            enqueueSnackbar({
                message: sagasMsgs.createApiKeyEx,
                options: {
                    variant: 'error'
                }
            })
        )
    }
}

async function createApiKeyRequest(body) {
    await axios.post(`${process.env.API_URL}/api-keys`, body)
}

function* deleteApiKey(action) {
    const sagasMsgs = yield select(getSagasMsgs)
    try {
        yield call(deleteApiKeyRequest, action.id)
        yield put(actions.deleteApiKeySuccess())
        yield put(
            enqueueSnackbar({
                message: sagasMsgs.deleteApiKeyRes,
                options: {
                    variant: 'success'
                }
            })
        )
        yield put(actions.apiKeysRequest())
    } catch (ex) {
        yield put(actions.deleteApiKeyError())
        yield put(
            enqueueSnackbar({
                message: sagasMsgs.deleteApiKeyEx,
                options: {
                    variant: 'error'
                }
            })
        )
    }
}

async function deleteApiKeyRequest(id) {
    await axios.delete(`${process.env.API_URL}/api-keys/${id}`)
}

function* getApiKey(action) {
    const sagasMsgs = yield select(getSagasMsgs)
    try {
        const response = yield call(getApiKeyRequest, action.id)
        yield put(actions.apiKeySuccess(response))
    } catch (ex) {
        yield put(actions.apiKeyError())
        yield put(
            enqueueSnackbar({
                message: sagasMsgs.getApiKeyEx,
                options: {
                    variant: 'error'
                }
            })
        )
    }
}

async function getApiKeyRequest(id) {
    const response = await axios.get(`${process.env.API_URL}/api-keys/${id}`)
    return response.data
}
